import Vue from 'vue';  
export default new Vue(); 


// WEBPACK FOOTER //
// ./src/global-event-bus.js